{
  "assetContainerEvent": {
    "types": {
      "arrived": "已到达",
      "arrivedWaiting": "已到达/等待中",
      "loading": "装货中",
      "loadingComplete": "装货完成",
      "unloading": "卸货中",
      "unloadingComplete": "卸货完成",
      "readyForPickup": "待提货",
      "departed": "已离开",
      "inoperable": "无法运行",
      "missing": "缺失",
      "inTransit": "运输中"
    }
  },
  "assetVisitYardEvent": {
    "Arrived": "已到达",
    "Docked": "已靠台",
    "Parked": "已停放",
    "Unassigned": "未分配",
    "Dropped": "已甩挂",
    "Hooked": "已挂接",
    "Appointment Linked": "已关联预约",
    "Appointment Unlinked": "已取消关联预约",
    "Status Updated": "状态更新"
  },
  "assetContainerTypes": {
    "trailer": "拖车",
    "container": "集装箱",
    "oversized": "超大件",
    "chassis": "底盘车",
    "reefer": "冷藏车",
    "other": "其他"
  },
  "assetVisitTypes": {
    "live": "现场装卸",
    "drop": "甩挂",
    "pickup": "挂接",
    "dropHook": "甩挂并挂接"
  },
  "assetVisitDirections": {
    "inbound": "入库",
    "outbound": "出库",
    "inboundAndOutbound": "入库与出库"
  },
  "loadTypeDirections": {
    "inbound": "入库",
    "outbound": "出库",
    "inOut": "入库 & 出库"
  },
  "altAssetVisitTypes": {
    "unknown": "未知"
  },
  "assetContainerStates": {
    "full": "满载",
    "empty": "空载",
    "partiallyLoaded": "部分装载"
  },
  "spotStatuses": {
    "open": "开放",
    "closed": "已关闭",
    "assigned": "已分配",
    "inTransit": "运输中",
    "reservedManual": "已预留",
    "reservedAutomated": "已预留",
    "unknown": "未知"
  },
  "spotTypes": {
    "parking": "停车",
    "docking": "靠台"
  },
  "labels": {
    "licensePlate": "车牌号",
    "dotNumber": "DOT 编号"
  },
  "messages": {
    "unknownCompany": "未知公司",
    "unhooked": "未挂接",
    "noInformationAvailable": "暂无信息",
    "noVisitFound": "未找到到访记录",
    "notInformed": "未提供",
    "waitingAssignment": "等待分配",
    "failedToLoadSpotDetails": "加载车位详情失败",
    "retry": "重试",
    "blockedUntilSpotIsOpen": "在 {spot} 开放之前受阻",
    "blockReasons": {
      "reservedByOther": "目标车位已被**移动任务 #{taskNumber}** **预留**。",
      "reservedByOtherGeneric": "目标车位已被**预留**。",
      "destinationClosed": "目标车位已**关闭**。",
      "destinationOccupied": "目标车位已被其他资产**占用**。",
      "anotherAssetInTransitForDestination": "**{assetCode}** 已在前往此车位的途中。",
      "assetInTransitElsewhere": "该资产已在由另一个移动任务移动中。"
    }
  }
}
